import { render } from "./RequestCallback.vue?vue&type=template&id=c01270b8"
import script from "./RequestCallback.vue?vue&type=script&lang=js"
export * from "./RequestCallback.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__